"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NOOP: function() {
        return NOOP;
    },
    arraysEqual: function() {
        return arraysEqual;
    },
    calculateProgress: function() {
        return calculateProgress;
    },
    capitalise: function() {
        return capitalise;
    },
    darkenHex: function() {
        return darkenHex;
    },
    dynamicSort: function() {
        return dynamicSort;
    },
    getIds: function() {
        return getIds;
    },
    getPercentageAmount: function() {
        return getPercentageAmount;
    },
    keyMirror: function() {
        return keyMirror;
    },
    mapImported: function() {
        return mapImported;
    },
    moveArrayItem: function() {
        return moveArrayItem;
    },
    numberFormatCurrency: function() {
        return numberFormatCurrency;
    },
    numberFormatWholeNumber: function() {
        return numberFormatWholeNumber;
    },
    partition: function() {
        return partition;
    },
    randomBool: function() {
        return randomBool;
    },
    reduceByKey: function() {
        return reduceByKey;
    },
    secondsToTime: function() {
        return secondsToTime;
    },
    shuffle: function() {
        return shuffle;
    },
    toBottom: function() {
        return toBottom;
    },
    toTop: function() {
        return toTop;
    },
    uniqBy: function() {
        return uniqBy;
    }
});
_export_star(require("./array-to-object"), exports);
_export_star(require("./dates"), exports);
_export_star(require("./pipe"), exports);
_export_star(require("./pluralize"), exports);
_export_star(require("./random-int"), exports);
_export_star(require("./randomise"), exports);
_export_star(require("./simulate"), exports);
_export_star(require("./group-teams"), exports);
_export_star(require("./group-by"), exports);
_export_star(require("./get-style"), exports);
_export_star(require("./get-id"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
function secondsToTime(e) {
    const cleanE = Number(e);
    const h = Math.floor(cleanE / 3600);
    const m = Math.floor(cleanE % 3600 / 60);
    const s = Math.floor(cleanE % 60);
    let result = "";
    if (h > 0) {
        result += `${h}h `;
    }
    if (m > 0) {
        result += `${m}m `;
    }
    if (s > 0 || result === "") {
        result += `${s}s`;
    }
    return result.trim();
}
function partition(array, predicate) {
    return array.reduce((acc, item)=>predicate(item) ? (acc[0].push(item), acc) : (acc[1].push(item), acc), [
        [],
        []
    ]);
}
function keyMirror(arr) {
    try {
        if (arr === undefined) {
            throw new Error(`objectKeyMirror: Error! Please supply and argument.`);
        } else if (!Array.isArray(arr)) {
            throw new Error(`objectKeyMirror: Error! Argument must be an array. ${arr} is not an array.`);
        }
        return arr.reduce((mirroredObject, token)=>{
            mirroredObject[token] = `${token}`;
            return mirroredObject;
        }, {});
    } catch (err) {
        console.error(err.message);
    }
}
function shuffle(arr) {
    const newArr = arr.slice();
    for(let i = newArr.length - 1; i > 0; i--){
        const rand = Math.floor(Math.random() * (i + 1));
        [newArr[i], newArr[rand]] = [
            newArr[rand],
            newArr[i]
        ];
    }
    return newArr;
}
function numberFormatWholeNumber(value) {
    return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short"
    }).format(Math.round(value));
}
function numberFormatCurrency(value) {
    return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        style: "currency",
        currency: "USD"
    }).format(value);
}
const getPercentageAmount = (total, points)=>points / total * 100;
const reduceByKey = (key, collection = [])=>collection.reduce((previousValue, currentValue)=>[
            ...currentValue?.[key],
            ...previousValue
        ], []);
const toTop = (top = 0)=>window.scrollTo({
        behavior: "smooth",
        top
    });
const capitalise = (string)=>{
    return string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : "";
};
function calculateProgress(partialValue, totalValue) {
    return 100 * partialValue / totalValue;
}
const toBottom = ()=>window?.scrollTo(0, document?.body?.scrollHeight);
const randomBool = ()=>Math.random() >= 0.5;
const dynamicSort = (property)=>{
    return function(a, b) {
        return a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    };
};
function mapImported(available = [], imported = []) {
    return available?.map((item)=>Object.assign({}, item, {
            imported: imported?.findIndex((inner)=>inner?.id === item?.id) > -1
        }));
}
function moveArrayItem(arr, oldIndex, newIndex) {
    while(oldIndex < 0){
        oldIndex += arr.length;
    }
    while(newIndex < 0){
        newIndex += arr.length;
    }
    if (newIndex >= arr.length) {
        var k = newIndex - arr.length;
        while(k-- + 1){
            arr.push(undefined);
        }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
}
const uniqBy = (a, key)=>{
    return [
        ...new Map(a.map((x)=>[
                key(x),
                x
            ])).values()
    ];
};
const getIds = (items)=>items.reduce((prev, curr)=>[
            ...prev,
            curr.wrestlerId
        ], []);
const NOOP = (val)=>val;
function s(x, y) {
    var pre = [
        "string",
        "number",
        "bool"
    ];
    if (typeof x !== typeof y) return pre.indexOf(typeof y) - pre.indexOf(typeof x);
    if (x === y) return 0;
    else return x > y ? 1 : -1;
}
function arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;
    const left = a.sort(s);
    const right = b.sort(s);
    for(var i = 0; i < left.length; ++i){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
const darkenHex = (hex, amount)=>{
    const color = hex.replace("#", "");
    const num = parseInt(color, 16);
    const r = (num >> 16) + amount;
    const b = (num >> 8 & 0x00FF) + amount;
    const g = (num & 0x0000FF) + amount;
    const newColor = g | b << 8 | r << 16;
    return `#${newColor.toString(16)}`;
};
